module.exports = __webpack_public_path__ + "img/service-zhunongjinrong2.5c97b030.svg";